<template>
  <div id="printArea">
    <!-- Kop & logo (print) -->
    <div class="print-only header text-center">
      <table class="w-full border-collapse" style="width: 100%; border-collapse: collapse">
        <tbody>
          <tr class="border-b border-transparent">
            <td class="text-center">
              <img
                src="../../../../public/img/hotel-deliriver.png"
                alt="Deli River Hotel Logo"
                style="width: 50px; height: auto"
              />
            </td>
          </tr>
          <tr class="border-b border-transparent">
            <td class="text-center">
              <h3>Deli River Hotel</h3>
              <p>Jl. Raya Namorambe No. 129, Medan, Indonesia</p>
              <p>www.hotel-deliriver.com</p>
              <p>contact@hotel-deliriver.com</p>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
    </div>

    <h3 class="text-center mb-3">
      Checkout Report
    </h3>

    <p class="text-center mb-4">
      Date Range: {{ startDate }} – {{ endDate }}
    </p>

    <!-- Table Report -->
    <div class="table-print">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>No</th>
            <th>Guest Name</th>
            <th>Res. Number</th>
            <th>Type</th>
            <th>Number</th>
            <th>Duration</th>
            <th>Check In</th>
            <th>Check Out</th>
            <th>Source</th>
            <th>Payment Status</th>
            <th class="text-end">Grand Total</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, i) in reservations" :key="data.id">
            <td class="text-center">{{ i + 1 }}</td>
            <td>{{ data.guest.fullname }}</td>
            <td>{{ data.number }}</td>
            <td>{{ data.room.room_category.name }}</td>
            <td class="text-center">{{ data.room.code }}</td>
            <td class="text-center">{{ data.days }}</td>
            <td>{{ data.start }}</td>
            <td>{{ data.end }}</td>
            <td>{{ data.source.name }}</td>
            <td>{{ data.payment_status }}</td>
            <td class="text-end">{{ formatCurrency(data.grand_total) }}</td>
            <td>{{ data.status }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Summary -->
    <p class="area-print mb-4">
      Total Check Out: {{ reservations.length }} reservation <br />
      Total Room: {{ reservations.reduce((sum, r) => sum + Number(r.days || 0), 0) }} <br />
      Total Revenue:
      {{ formatCurrency(reservations.reduce((sum, r) => sum + r.grand_total, 0)) }}
    </p>
  </div>
</template>
<script setup>
/* ============================
 * IMPORTS
 * ============================ */
import { ref, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import reservationRepository from "@/repositories/reservationRepository";

/* ============================
 * ROUTE & QUERY PARAMS
 * ============================ */
const route = useRoute();

const startDate = route.query.start_date;
const endDate = route.query.end_date;

const reservations = ref([]);

const formatCurrency = (value) => {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
  }).format(value || 0);
};

/* ============================
 * DATA FETCH
 * ============================ */
const fetchReservations = async () => {
  const res = await reservationRepository.getAll({
    start: startDate,
    end: endDate,
    status: "Check Out",
    per_page: 9999,
  });

  reservations.value = res.data.data;
};

/* ============================
 * PRINT ENGINE (CORE TEMPLATE)
 * ============================ */
const handlePrint = () => {
  nextTick(() => {
    const printArea = document.getElementById("printArea");
    if (!printArea) return;

    const iframe = document.createElement("iframe");
    Object.assign(iframe.style, {
      position: "fixed",
      right: "0",
      bottom: "0",
      width: "0",
      height: "0",
      border: "0",
    });

    document.body.appendChild(iframe);

    const doc = iframe.contentDocument || iframe.contentWindow.document;

    doc.open();
    doc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Checkout Report</title>
          <style>
            @page {
              size: A4 landscape;
              margin: 15mm 100mm 15mm 45mm;
            }

            body {
              font-family: Arial, sans-serif;
              font-size: 12px;
              margin: 0;
              padding: 0;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            th, td {
              border: 1px solid #000;
              padding: 6px;
            }

            .border-transparent,
            .border-transparent th,
            .border-transparent td {
              border: none !important;
            }

            .header {
              text-align: center;
              line-height: 1.3;
            }

            .header p {
              margin: 2px 0;
            }

            .text-center { text-align: center; }
            .text-end { text-align: right; }

            .table-print {
              margin: 0 15mm;
            }

            .area-print {
              margin: 5mm 15mm;
            }
          </style>
        </head>
        <body>
          ${printArea.innerHTML}
        </body>
      </html>
    `);
    doc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();

      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  });
};

/* ============================
 * LIFECYCLE
 * ============================ */
onMounted(async () => {
  await fetchReservations();
  await nextTick();
  handlePrint();
  window.onafterprint = () => window.close();
});
</script>
